<template>
  <div class="destGroup t-left mb-xl">
    <div class="loading-wrapper" :class="{loading: isCardsLoading}">
      <slot name="header">
        <div class="t-title sm mb-m" v-html="name"></div>
      </slot>
      <!-- <BShowAll bShowAll :active="isAllShown" @click="$emit('show-all', name)" v-if="isShowAllAvailable">{{
        showAllCaption
      }}</BShowAll> -->
      <slot name="right-header" />
    </div>
    <div class="container">
      <slot>
        <div class="row" v-for="(row, index) in rows" :key="row.id">
          <div class="column" v-for="(card, cardIndex) in row.cards" :ref="card.city" :key="card.city">
            <DestinationCard
              :id="index === 0 && cardIndex === 0 ? firstCardId : card.city"
              :key="card.city"
              :img="card.img"
              :location="card.location"
              :city="card.city"
              :tags="card.matchedTags"
              :selectedTags="selectedTags"
              :isLoading="isCardsLoading"
              :isSelected="card.id === cardDetails.id"
              @click="onCardClick(card)"
            />
          </div>
          <!-- <transition name="expand"> -->
          <DestinationDetails
            v-if="row.id === activeRowId"
            :img="cardDetails.img"
            :location="cardDetails.location"
            :city="cardDetails.city"
            :description="cardDetails.description"
            :tripOptions="cardDetails.tripOptions"
            :isLoading="isOptionsLoaidng"
            :isFlightLoading="isFlightLoading"
            :to="to"
            @trip-selected="$emit('trip-selected', $event)"
            :selectedTrip="selectedTrip"
            :recommendations="recommendationsForSelectedTrip"
            :samples="samplesForSelectedTrip"
            :selectedTags="selectedTags"
            @toggle-tag="onToggleTag"
            @on-add-preferences="onAddPreferences"
          />
          <!-- </transition> -->
        </div>
      </slot>
      <BaseBtn
        class="show-more-btn"
        :class="{active: isAllShown}"
        @click="$emit('show-all', name)"
        v-if="isShowAllAvailable"
      >
        <span
          ><span>{{ showAllCaption }}</span></span
        >
      </BaseBtn>
    </div>
  </div>
</template>

<script>
import DestinationCard from './dest-card.vue';
import BaseBtn from '@common/button/base-button.vue';
import DestinationDetails from './dest-details';

export default {
  name: 'DestinationGroup',
  components: {
    DestinationCard,
    BaseBtn,
    DestinationDetails,
  },
  props: {
    firstCardId: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    cards: {
      type: Array,
      default: () => [],
    },
    selectedTags: {
      type: Array,
      default: () => [],
    },
    isAllShown: {
      type: Boolean,
      default: false,
    },
    isShowAllAvailable: {
      type: Boolean,
      default: true,
    },
    showAllCaption: {
      type: String,
      default: 'Show More',
    },
    activeCardDescription: {
      type: String,
      default: '',
    },
    activeCard: {
      type: Object,
      default: () => null,
    },
    activeCardTrips: {
      type: Array,
      default: () => [],
    },
    isOptionsLoaidng: {
      type: Boolean,
      default: false,
    },
    isFlightLoading: {
      type: Boolean,
      default: false,
    },
    isCardsLoading: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
    flightsMessage: String,
    recommendationsForSelectedTrip: {
      type: Array,
      default: () => [],
    },
    selectedTrip: {
      type: Object,
      default: () => null,
    },
    samplesForSelectedTrip: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    rows() {
      return this.cards.reduce((res, card, index) => {
        const cardInaRowIndex = index % 4;
        if (!cardInaRowIndex) {
          const r = {id: index, cards: [card], rowId: index + this.name};
          return [...res, r];
        }

        const last = res[res.length - 1];
        last.cards.push(card);
        return res;
      }, []);
    },
    activeRowId() {
      return Math.floor(this.cards.findIndex((x) => Boolean(this.activeCard) && this.activeCard.id === x.id) / 4) * 4;
    },
    cardDetails() {
      return {
        id: this.activeCard ? this.activeCard.id : '',
        img: this.activeCard ? this.activeCard.img : '',
        location: this.activeCard ? this.activeCard.location : '',
        city: this.activeCard ? this.activeCard.city : '',
        description: this.activeCardDescription || '',
        tripOptions: this.activeCardTrips || [],
      };
    },
  },
  methods: {
    onToggleTag(selectedTags) {
      this.$emit('toggle-tag', selectedTags);
    },
    onAddPreferences(category) {
      this.$emit('on-add-preferences', {type: 'INTERESTS'}, category);
    },
    onCardClick(card) {
      this.$emit('card-selected', card);
      setTimeout(function() {
        const targetElement = document.querySelector('#' + card.city);
        targetElement?.scrollIntoView();
      }, 200);
    },
  },
};
</script>

<style scoped>
.loading-wrapper.loading > * {
  background: #f1f1f1;
  border-radius: 20px;
  color: transparent;
  display: inline-block;
}

.loading-wrapper.loading > *::after {
  content: none;
}

.destGroup {
  position: relative;
}
.destGroup .b-showall {
  position: absolute;
  top: 0;
  right: 0;
}
.destGroup .container {
  margin: 0;
  width: 100%;
}

.destGroup .column {
  width: 25%;
  padding: 0 20px 20px 0;
  display: inline-block;
}

.expand-enter-active {
  transition: max-height 0.5s ease-in-out, margin 0.5s ease-in-out;
  max-height: 1000px;
  margin: 55px -100px;
  overflow: hidden;
}

.expand-leave-active {
  transition: max-height 0.5s ease-in-out, margin 0.5s ease-in-out;
  max-height: 1000px;
  margin: 55px -100px;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  margin: 0 -110px;
  overflow: hidden;
}

.show-more-btn {
  font-size: 16px;
  position: relative;
  border: 0;
  appearance: none;
  background-color: transparent;
  color: #555;
  line-height: 30px;
  height: 26px;
  width: 100%;
}

.show-more-btn > span {
  display: flex;
}

.show-more-btn > span::before,
.show-more-btn > span::after {
  content: '';
  top: 14px;
  position: relative;
  flex: 1;
  width: 100%;
  height: 1px;
  background-color: #a3abb6;
  flex: 1;
}
.show-more-btn > span::before {
  margin-right: 30px;
}
.show-more-btn > span::after {
  margin-left: 30px;
}

.show-more-btn > span > span::after {
  content: '';
  top: 0;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(./icon-filter-downarrow.svg);
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  opacity: 0.5;
  transition: transform 0.2s linear;
  transform-origin: 75% center;
  will-change: transform;
}

.show-more-btn.active > span > span::after {
  transform: rotate(60deg);
}
</style>
